import {on} from 'delegated-events'
import {getBaseFetchHeaders} from '@github-ui/fetch-headers'

on('click', '.js-new-user-contrib-example', async function (event) {
  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  const container = document.querySelector<HTMLElement>('.js-calendar-graph')!
  if (container.classList.contains('sample-graph')) {
    return
  }
  container.classList.add('sample-graph')

  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  const url = event.currentTarget.getAttribute('data-url')!

  const response = await fetch(url, {
    headers: {...getBaseFetchHeaders()},
  })
  if (!response.ok) {
    container.classList.remove('sample-graph')
    return
  }
  const html = await response.text()

  const tmp = document.createElement('div')
  // eslint-disable-next-line @github-ui/github-monorepo/require-set-sanitized-inner-html -- pre-existing innerHTML sink grandfathered when enabling the rule; not migrated in this rollout
  tmp.innerHTML = html

  const svg = container.querySelector('.js-calendar-graph-table')

  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  svg?.replaceWith(tmp.children[0]!)
})
